import { signupApi } from '@saucelabs/sl-util-axios';
import { constants as sentryConstants, Sentry } from '@saucelabs/sl-util-sentry';
import { useEffect } from 'react';

import { TRACK_USER_HAS_VISITED_VISUAL } from '../constants';
import { useVisualSelector } from '../reduxHooks';
import { selectors } from '../ducks/filterBar';

const useGrowthUserAttribute = (event: string):void => {
  const userId = useVisualSelector(selectors.getUserId);
  useEffect(() => {
    if (!userId) return;
    const storageKey = `${TRACK_USER_HAS_VISITED_VISUAL}-${event}-${userId}`;
    const hasAlreadyTracked = useGrowthUserAttribute.events[event] ||
          !!localStorage.getItem(storageKey);
    if (!hasAlreadyTracked) {
      useGrowthUserAttribute.events[event] = true;
      const endpoint = `/api/userPreferences/${event}`;
      signupApi.post(endpoint)
        .then(() => {
          // when the API call is successful, mark in local storage that it's done so that
          // it's never called again
          localStorage.setItem(storageKey, 'true');
        })
        .catch((err) => {
          // log to Sentry if the API call fails
          Sentry.withScope((scope) => {
            scope.setTag('owner', sentryConstants.TEAMS.GROWTH);
            Sentry.captureException(err);
          });
        });
    }
  }, [userId, event]);
};

useGrowthUserAttribute.events = {};

export default useGrowthUserAttribute;
